import React from 'react';
import PageHeader from "../../components/PageHeader";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Notifications from "../../components/Notifications";
import CircularProgress from '@material-ui/core/CircularProgress';

import {
    Grid,
    TableBody,
    Paper,
    Toolbar,
    TableRow,
    TableCell,
    InputAdornment,
    TableContainer,
    Table,
    TableHead,
    TablePagination,
    TableFooter,
    Chip,
    TextField
} from "@material-ui/core";
import CommentIcon from '@material-ui/icons/Comment';
import ActionButton from "../../components/controls/ActionButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { withStyles } from '@material-ui/core/styles';
import Input from "../../components/controls/Input";
import Button from "../../components/controls/Button";
import AddIcon from "@material-ui/icons/Add";
import { ContactlessOutlined, Search, FilterList as FilterListIcon } from "@material-ui/icons";
import axios from "axios";
import NewOrderBookingForm from "./NewOrderBookingForm"
import { Dialog } from "../../components/Dialog";
import moment from "moment";
import { getCurrentUser } from '../../services/userService'
import { Redirect } from 'react-router-dom';
const cssStyles = ((theme) => ({
    pageContent: {
        // margin: theme.spacing(5),
        padding: theme.spacing(3),
    },
    toolbar: theme.mixins.toolbar,

    searchInput: {
        width: "58%",
        marginLeft: "18px",
        marginRight: "12px"
    },
    exportButton: {
        position: "relative",
        fontSize: "12px"
    },
    bookOrderButton: {
        position: "relative",
        fontSize: "12px",
        whiteSpace: "nowrap"
    },
    acceptButton: {
        position: "relative",
        fontSize: "12px",
        whiteSpace: "nowrap",
        backgroundColor: '#4caf50',
        '&:hover': {
            backgroundColor: "#139018",
        },
    },
    rejectButton: {
        position: "relative",
        fontSize: "12px",
        whiteSpace: "nowrap"
    },
    container: {
        display: "block",
        maxWidth: "85vw",
        overflowX: "auto",
        marginRight: "auto",
        marginLeft: "auto",
        padding: "2px",
        margin: "5px",
        fontSize: "12px",
    },
}));
const date = moment().format('YYYY-MM-DD');
class OrderBooking extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            start_date: date,
            end_date: date,
            searchTerm: "",
            stabletableData: [],
            isDisableComment: false,
            user: {},
            totalCount: 0,
            pageNum: 0,
            rowsPerPage: 10,
            tableData: [],
            notify: {
                isOpen: false,
                message: "",
                type: "",
            },
            loading: false,
            showPopup: false,
            rowData: null,
            isBookOrderDialogOpen: false,
            userType: localStorage.getItem('user_type'),
            rejectDialogData: null,
           
            rejectionReason: null,
            orderStatusError: null,
            currentUser: [],
            resTable: null,
        };
        this.setFilterFn = {
            fn: (items) => {
                return items;
            },
        }
        this.getTableDataRows = this.getTableDataRows.bind(this);
        this.getCurrentUserFunc = this.getCurrentUserFunc.bind(this);
        this.getTableHeaderRow = this.getTableHeaderRow.bind(this);
        this.shouldAllowOrderBooking = this.shouldAllowOrderBooking.bind(this);
        this.orderStatusRenderCode = this.orderStatusRenderCode.bind(this);
        this.SERVERBASEURL = process.env.REACT_APP_API;
        this.token = localStorage.getItem("token");
        this.openPopupEdit = this.openPopupEdit.bind(this)
        this.openPopupShow = this.openPopupShow.bind(this)
    }
    getCurrentUserFunc = async () => {
        this.setState({ loading: true })
        const user = await getCurrentUser()
        if (user && user.data){
            this.setState({ currentUser: user.data.body })
        }
        this.setState({ loading: false })
    }
    componentDidMount() {
        this.getTableDataRows();
        this.getCurrentUserFunc()
    }
    formatDate(date) {
        moment(date).format("DD:MM:yyyy")
    }
    createData(order_booking_id, orgId, distributorName, quantity, releaseRate, discountRate, totalDiscount, finalRate, created, orderBookingStatus, orderBookingReferenceNumber, createdByUserType, created_by_user_id, reason_for_rejection, created_order, refNo) {
        return { order_booking_id, orgId, distributorName, quantity, releaseRate, discountRate, totalDiscount, finalRate, created, orderBookingStatus, orderBookingReferenceNumber, createdByUserType, created_by_user_id, reason_for_rejection, createdOrder: created_order, refNo };
    }

    // getTableDataRows() {
    //     var self = this;
    //     self.setState({ loading: true })
    //     axios({
    //         method: 'get',
    //         url: self.SERVERBASEURL + "/order_booking/" + self.getCurrentDate(),
    //         headers: {
    //             Accept: 'application/json',
    //             Authorization: `Bearer ${this.token}`,
    //         },
    //     })
    //         .then((res, req) => {
    //             var tableData = [];

    //             res.data.data.data.reverse().forEach((item, index) => {

    //                 tableData.push(
    //                     self.createData(
    //                         item.order_booking_id,
    //                         item.org_id,
    //                         item.org_name,
    //                         item.quantity,
    //                         item.release_rate,
    //                         item.discount_rate,
    //                         item.total_discount,
    //                         item.final_rate,

    //                         moment(item.created_order).format("DD/MM/yyyy"),
    //                         item.order_booking_status,
    //                         item.order_booking_reference_number,
    //                         item.createdby_usertype,
    //                         item.created_by_user_id,
    //                         item.reason_for_rejection,
    //                         item.created_order,
    //                         item.order_booking_reference_number,
    //                     ));
    //             });

    //             self.setState({ tableData, stabletableData: tableData, user: res.data.user });

    //         })
    //         .catch(err => console.log('Error in performing operation', err));
    //     self.setState({ loading: false })
    // }
getTableDataRows(page = this.state.pageNum + 1, limit = this.state.rowsPerPage, search = this.state.searchTerm, startDate = this.state.start_date, endDate = this.state.end_date) {
    var self = this;
    self.setState({ loading: true });

    let queryParams = `?page=${page}&limit=${limit}`;
    if (search && search.trim() !== '') {
        queryParams += `&search=${encodeURIComponent(search.trim())}`;
    }
    if (startDate && startDate.trim() !== '') {
        queryParams += `&start_date=${startDate.trim()}`;
    }
    if (endDate && endDate.trim() !== '') {
        queryParams += `&end_date=${endDate.trim()}`;
    }

    axios({
        method: 'get',
        url: self.SERVERBASEURL + "/order_booking/" + self.getCurrentDate() + queryParams,
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${this.token}`,
        },
    })
    .then((res) => {
        console.log('API Response:', res.data);
        
        var tableData = [];
        var responseData = [];
        var total = 0;
        
        if (res.data && res.data.data) {
            if (res.data.data.data) {
                responseData = res.data.data.data || [];
                total = res.data.data.total || responseData.length;
            } else if (Array.isArray(res.data.data)) {
                responseData = res.data.data || [];
                total = res.data.total !== undefined ? res.data.total : responseData.length;
            }
        }
        
        responseData.forEach((item) => {
            tableData.push(
                self.createData(
                    item.order_booking_id || item.id,
                    item.org_id,
                    item.org_name,
                    item.quantity,
                    item.release_rate,
                    item.discount_rate,
                    item.total_discount,
                    item.final_rate,
                    moment(item.created_order || item.created).format("DD/MM/yyyy"),
                    item.order_booking_status,
                    item.order_booking_reference_number,
                    item.createdby_usertype,
                    item.created_by_user_id,
                    item.reason_for_rejection,
                    item.created_order || item.created,
                    item.order_booking_reference_number,
                ));
        });
        
        self.setState({ 
            tableData, 
            stabletableData: tableData, 
            user: res.data.user,
            totalCount: total
        });
    })
    .catch(err => console.log('Error in performing operation', err))
    .finally(() => self.setState({ loading: false }));
}
    getTableHeaderRow() {
    return [
        { id: 'distributorName', label: 'Distributor Name', minWidth: 170 },
        { id: 'quantity', label: 'Quantity (MT)', minWidth: 70 },
        { id: 'releaseRate', label: 'Release Rate (Rs)', minWidth: 70 },
        { id: 'refNo', label: 'Reference No', minWidth: 70 },
        { id: 'discountRate', label: 'Discount Rate (Rs)', minWidth: 70 },
        { id: 'totalDiscount', label: 'Total Discount (Rs)', minWidth: 70 },
        { id: 'finalRate', label: 'Final Rate (Rs)', minWidth: 70 },
        { id: 'created', label: 'Date', minWidth: 70 },
        { id: 'orderBookingStatus', label: 'Order Booking Status', minWidth: 158, renderCode: this.orderStatusRenderCode },
        { id: 'actionColumn', label: 'Action', minWidth: 70, type: 'Action' }, // Changed id from orderBookingStatus to actionColumn
    ]
}
    handleDateChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };
    orderStatusRenderCode(value, orderBookingId, createdByUserType, row) {
        const { classes } = this.props;
        if (value === "pending" && (this.state.userType !== createdByUserType && this.state.userType !== "sales_person")) {
            return (<div style={{ display: "inline-grid" }}>
                <Button
                    text="Accept"
                    variant="contained"
                    className={classes.acceptButton}
                    color="secondary"
                    onClick={(e) => { this.updateStatusOfOrderBooking(orderBookingId, "accepted", row); }}
                />
                <Button
                    text="Reject"
                    variant="contained"
                    className={classes.rejectButton}
                    color="secondary"
                    onClick={(e) => { this.setBookingStatusToReject(orderBookingId, row); }}
                />
            </div>
            )
        }
        else {
            return (<Chip label={value} />);
        }
    }

    setBookingStatusToReject(orderBookingId, row) {
        this.setState({
            rejectDialogData: {
                order_booking_id: orderBookingId,
            },
            rowData: row,
            showPopup: true,
            isDisableComment: false
        });
    }
    openPopupShow = (rejection_reason) => {
        this.setState({
            ...this.state,
            showPopup: true,
            rejectionReason: rejection_reason,
            isDisableComment: true
        })
    }

    updateStatusOfOrderBooking(id, newStatus, row) {
        var self = this;
        axios({
            method: 'get',
            url: self.SERVERBASEURL + "/order_booking/" + id + "/" + newStatus + "/" + this.state.rejectionReason + "/" + row.created_by_user_id,
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${self.token}`,
            },
        })
            .then(res => {
                if (res.data.statusCode === 400) {
                    this.setState({
                        notify: {
                            isOpen: true,
                            message: res.data.message,
                            type: "error",
                        }
                    })
                }
                self.getTableDataRows()

            }).catch(err =>
                console.log('Error in performing operation', err));

        this.setState({ rejectDialogData: null, rejectionReason: null, showPopup: false })
    }

    getCurrentDate() {
        return moment().format('YYYY-MM-DD');
    }

    shouldAllowOrderBooking() {
        return true;
    }

    handleDialogOpen() {
        if (this.shouldAllowOrderBooking()) {
            this.setState({ isBookOrderDialogOpen: true });
        }
    }
    openPopupEdit(row) {
        this.setState({ isBookOrderDialogOpen: true, rowData: row })
    }
    // handleSearch = (e) => {
    //     let target = e.target;
    //     let res
    //     if (target.value === "") {
    //         res = this.state.stabletableData
    //     } else {
    //         res = this.state.stabletableData.filter((val) => {
    //             return val.distributorName.toLowerCase()
    //                 .includes(target.value.toLowerCase()) || 
    //              val.orderBookingReferenceNumber
    //                 .includes(target.value)
    //         })
    //     }
    //     this.setState({ ...this.state, tableData: res })

    // };

    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    };

    handleApplyFilter = () => {
        this.setState({ pageNum: 0 }, () => {
            this.getTableDataRows(1, this.state.rowsPerPage, this.state.searchTerm, this.state.start_date, this.state.end_date);
        });
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleApplyFilter();
        }
    };

    handleChangePage = (event, newPage) => {
        this.setState({ pageNum: newPage }, () => {
            this.getTableDataRows(newPage + 1, this.state.rowsPerPage, this.state.searchTerm, this.state.start_date, this.state.end_date);
        });
    };

    handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        this.setState({ rowsPerPage: newRowsPerPage, pageNum: 0 }, () => {
            this.getTableDataRows(1, newRowsPerPage, this.state.searchTerm, this.state.start_date, this.state.end_date);
        });
    };
    render() {

        // var paginatedTableData = this.state.rowsPerPage > 0 ? this.state.tableData.slice(this.state.pageNum * this.state.rowsPerPage, this.state.pageNum * this.state.rowsPerPage + this.state.rowsPerPage) : this.state.tableData;

        const { classes } = this.props;
        return (<>

            <main className={classes.pageContent}>
                <div className={classes.toolbar} />

                <Paper style={{ paddingTop: "20px" }}>

                    <Toolbar style={{ padding: "15px" }}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} md={4}>
                                <Input
                                    label="Search by Organization name or reference no."
                                    style={{ width: "100%" }}
                                    value={this.state.searchTerm}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                    onChange={this.handleSearchChange}
                                    onKeyPress={this.handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} style={{ display: 'flex', gap: '10px' }}>
                                <TextField
                                    name="start_date"
                                    label="Start Date"
                                    type="date"
                                    value={this.state.start_date ? moment(this.state.start_date).format('YYYY-MM-DD') : ''}
                                    onChange={this.handleDateChange}
                                    onKeyPress={this.handleKeyPress}
                                    className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <TextField
                                    name="end_date"
                                    label="End Date"
                                    type="date"
                                    value={this.state.end_date ? moment(this.state.end_date).format('YYYY-MM-DD') : ''}
                                    onChange={this.handleDateChange}
                                    onKeyPress={this.handleKeyPress}
                                    className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Button
                                    text="Filter"
                                    variant="contained"
                                    color="primary"
                                    startIcon={<FilterListIcon />}
                                    onClick={this.handleApplyFilter}
                                />
                                {this.state.currentUser && this.state.userType !== "sales_person" && this.state.currentUser.status === 1 &&
                                    <Button
                                        text="Book Order"
                                        variant="contained"
                                        className={classes.bookOrderButton}
                                        onClick={(e) => this.handleDialogOpen()}
                                    />
                                }
                            </Grid>
                        </Grid>
                    </Toolbar>


                    {this.state.loading === false ? <TableContainer className={classes.container}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {this.getTableHeaderRow().map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                               {this.state.tableData.map((row) => (<TableRow hover role="checkbox" tabIndex={-1} key={row.orderBookingReferenceNumber}>
                                    {this.getTableHeaderRow().map((column) => {
                                        const value = row[column.id];
                                        if (column.renderCode && this.state.currentUser && this.state.currentUser.status === 1) {
                                            return (<TableCell key={column.id} align={column.align}>{column.renderCode(value, row.order_booking_id, row.createdByUserType, row)}</TableCell>);
                                        }
                                        // else if (column.type === "Action") {
                                        //     console.log('--value', value)
                                        //     return ()
                                        // }
                                        else if (column.type !== "Action") {
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                </TableCell>
                                            )
                                        };

                                    })}
                                    {this.state.currentUser && <><TableCell> {<> {

                                        row.orderBookingStatus !== "accepted" && this.state.user.id === row.created_by_user_id &&

                                        <ActionButton color="primary">
                                            <EditOutlinedIcon
                                                onClick={(e) => this.openPopupEdit(row)}
                                                fontSize="small"
                                            />
                                        </ActionButton>

                                    }
                                        {
                                            row.orderBookingStatus === "rejected" &&
                                            // <TableCell>

                                            <ActionButton color="primary">
                                                <CommentIcon
                                                    onClick={(e) => this.openPopupShow(row.reason_for_rejection)}
                                                    fontSize="small"
                                                />
                                            </ActionButton>
                                            // </TableCell>
                                        }</>}</TableCell></>}
                                </TableRow>))}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                  <TablePagination
    rowsPerPageOptions={[5, 10, 25, 50]}
    colSpan={3}
    count={this.state.totalCount}
    rowsPerPage={this.state.rowsPerPage}
    page={this.state.pageNum}
    onPageChange={this.handleChangePage}
    onRowsPerPageChange={this.handleChangeRowsPerPage}
/>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer> : <>
                            <CircularProgress />
                        </>
                    }
                </Paper>
                <Dialog
                    heading="Add Order Booking"
                    handleClose={(e) => { this.setState({ isBookOrderDialogOpen: false, rowData: null, showPopup: false, isDisableComment: false }) }}
                    open={this.state.isBookOrderDialogOpen}
                    width="md"
                >
                    <NewOrderBookingForm
                        closeDialog={() => {
                            this.setState({ isBookOrderDialogOpen: false, rowData: null });
                            this.getTableDataRows();
                        }} orderDetails={this.state.rowData} />
                </Dialog>
                <Dialog
                    heading="Reason For Rejection"
                    handleClose={(e) => { this.setState({ rejectDialogData: null, rejectionReason: null, showPopup: false }) }}
                    open={this.state.showPopup}
                    width="sm"
                >

                    {this.state.orderStatusError != null && this.state.orderStatusError.length > 0 && <Chip label={this.state.orderStatusError} />}
                    <TextField
                        required
                        multiline
                        rows={4}
                        disabled={this.state.isDisableComment}
                        name="rejectionReason"
                        value={this.state.rejectionReason}
                        label="Reason For Rejection"
                        style={{ width: "100%", fontSize: "12px" }}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                            const { name, value } = e.target;
                            var kv = {};
                            kv[name] = value;
                            kv["orderStatusError"] = null;
                            this.setState({ ...kv });
                        }}
                    />
                    {!this.state.isDisableComment && <Grid item>
                        <Button text="Submit"
                            type="submit"
                            onClick={(e) => {
                                e.preventDefault();
                                if (this.state.rejectionReason == null || this.state.rejectionReason.trim().length < 1) {
                                    this.setState({ orderStatusError: "Please give a reason for rejecting this order booking" });
                                } else {
                                    this.updateStatusOfOrderBooking(this.state.rejectDialogData.order_booking_id, "rejected", this.state.rowData);
                                }
                            }} />
                    </Grid>}

                </Dialog>
                <Notifications notify={this.state.notify} isClass={false} setNotify={(notifyReq) => { this.setState({ notify: { isOpen: false, message: '', error: '' } }) }} />
                {<>{this.state.currentUser === null && <Redirect to='/' />}</>}
            </main>
        </>);
    }
}

export default withStyles(cssStyles)(OrderBooking);